import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "../lib/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#050505]/80 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <button
          data-testid="logo-link"
          onClick={() => go("top")}
          className="font-display text-2xl md:text-3xl tracking-tight uppercase text-white hover:text-[#FF2222] transition-colors flex items-baseline gap-2"
        >
          iza3nee <span className="text-[#FF2222]">creations</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {SITE.nav.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="text-xs uppercase tracking-[0.2em] font-medium text-white/80 hover:text-[#FF2222] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="header-quote-btn"
            onClick={() => go("contact")}
            className="bg-[#FF2222] hover:bg-white hover:text-black text-white uppercase font-bold tracking-wider text-xs px-6 py-3 transition-colors"
          >
            Get a Quote
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#050505]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {SITE.nav.map((n) => (
              <button
                key={n.id}
                data-testid={`nav-mobile-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left text-sm uppercase tracking-[0.2em] text-white/90 hover:text-[#FF2222]"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="header-quote-btn-mobile"
              onClick={() => go("contact")}
              className="mt-2 bg-[#FF2222] text-white uppercase font-bold tracking-wider text-xs px-6 py-3 w-fit"
            >
              Get a Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
